module.exports = __webpack_public_path__ + "8250d10eadc1342e2195433f0d61d83a.svg";